import { ThemeOptions, createTheme } from '@mui/material';

import components from './components';
import * as options from './options';

const theme: ThemeOptions = {
  ...options,
  components,
  shape: { borderRadius: 5 }
};

export default createTheme(theme);
